.toolbar {
	display: flex;
	align-items: center;
	width: 100%;
	min-width: 0;
	gap: 8px;
	flex-wrap: wrap;
	--settings-toolbar-height: 40px;
	--settings-toolbar-radius: 4px;
}

/* Normalize height/margin for any MUI input-like control placed directly in the toolbar
   (search fields, text fields, dropdowns), regardless of how deeply each wraps its input. */
.toolbar :global(.MuiInputBase-root) {
	height: var(--settings-toolbar-height);
	min-height: var(--settings-toolbar-height);
	margin: 0;
	box-sizing: border-box;
}

.toolbar :global(.MuiOutlinedInput-root) {
	border-radius: var(--settings-toolbar-radius);
}

.toolbar :global(.MuiInputBase-root) :global(.MuiSelect-select) {
	display: flex;
	align-items: center;
	height: 100%;
	min-height: 0;
	box-sizing: border-box;
	padding-top: 0;
	padding-bottom: 0;
}

.toolbarField {
	flex: 1 1 240px;
	min-width: 0;
}

.toolbarButton:global(.MuiButtonBase-root) {
    flex: 0 0 auto;
    width: fit-content;
    height: 40px;
    min-height: 40px;
    box-sizing: border-box;
    padding: 0 16px;
    border-radius: 4px;
    margin: 0;
    line-height: 18px;
    white-space: nowrap;
    min-width: 96px;
    font-size: 14px;
}

@media (max-width: 768px) {
	.toolbar {
		align-items: stretch;
	}

	.toolbarField {
		flex-basis: 100%;
	}

	.toolbarButton:global(.MuiButtonBase-root) {
		flex: 1 1 auto;
		width: auto;
	}
}
